import { render, staticRenderFns } from "./ShowObservationHistory.vue?vue&type=template&id=6b31a370&"
import script from "./ShowObservationHistory.vue?vue&type=script&lang=ts&"
export * from "./ShowObservationHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports